module.exports = __webpack_public_path__ + "static/img/ent-detail-92.a3668e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-92.jpg
// module id = 5nOx
// module chunks = 52